import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HEATMAP_MIN_TRANSPARENCY } from "config/heatmap";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedTransparencyState {
  selectedTransparency: number;
}

const initialState: SelectedTransparencyState = {
  selectedTransparency: HEATMAP_MIN_TRANSPARENCY,
};

const selectedTransparencySlice = createSlice({
  name: "selectedTransparency",
  initialState: initialState,
  reducers: {
    resetSelectedTransparency: () => initialState,
    setSelectedTransparency: (state, action: PayloadAction<number>) => {
      state.selectedTransparency = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const selectedTransparency = action.payload.projectSettings.selectedTransparency;
      return selectedTransparency ?? initialState;
    });
  },
});

export const { setSelectedTransparency, resetSelectedTransparency } = selectedTransparencySlice.actions;

export default selectedTransparencySlice.reducer;
